var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatThread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33292 7.66667L7.66625 9L10.6663 6M8.33292 13.3333C11.4625 13.3333 13.9996 10.7963 13.9996 7.66667C13.9996 4.53705 11.4625 2 8.33292 2C5.20331 2 2.66625 4.53705 2.66625 7.66667C2.66625 8.3 2.77015 8.90906 2.96183 9.47774C3.03397 9.69175 3.07003 9.79875 3.07654 9.88095C3.08296 9.96213 3.07811 10.019 3.05802 10.098C3.03769 10.1779 2.99278 10.261 2.90298 10.4272L1.81254 12.4456C1.657 12.7335 1.57923 12.8774 1.59664 12.9885C1.6118 13.0853 1.66875 13.1705 1.75237 13.2215C1.84837 13.2801 2.01112 13.2632 2.33661 13.2296L5.75063 12.8767C5.85402 12.866 5.90571 12.8606 5.95283 12.8624C5.99917 12.8642 6.03188 12.8686 6.07708 12.879C6.12302 12.8896 6.1808 12.9118 6.29636 12.9564C6.92839 13.1999 7.61507 13.3333 8.33292 13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatThread);
export default __webpack_public_path__ + "static/media/chat-thread.d85f3936d4f0fa1cb7e7e74e62e7512a.svg";
export { ForwardRef as ReactComponent };